// extracted by mini-css-extract-plugin
export default {"contents":"tF-z","sectionHeading":"uF-z"};